import * as React from 'react';
import { RadioSymbol, DateTime } from 'ui';
import { parseAsDateUTC, createUTCDate, dateToUTC, createFormatters } from 'app/infrastructure/data/date';
import { FilterCommonProps, OptionType, SubOptionType } from './types';
import { getValue } from './get-value';

import styles from './filter-date-range.scss';
import { MeatballPanel } from 'app/area/search-filters/filters/meatball-panel';

export class FilterDateRange extends React.PureComponent<FilterCommonProps<Date>> {

  private onChange = (e: React.SyntheticEvent<any>) => {
    const optionType = e.currentTarget.value;
    const notSpecified = optionType === OptionType.notSpecified;

    this.props.onChange(this.props.id, [{
      optionType,
      value: notSpecified ? {} as any : undefined
    }]);
  };

  private onChangeDate = (value: Date, subOptionType: SubOptionType) => {
    const { values } = this.props;

    this.props.onChange(this.props.id, [{
      optionType: OptionType.specified,
      subOptionType: SubOptionType.dateFrom,
      value: subOptionType === SubOptionType.dateFrom ? value : getValue(values, SubOptionType.dateFrom).value
    }, {
      optionType: OptionType.specified,
      subOptionType: SubOptionType.dateTo,
      value: subOptionType === SubOptionType.dateTo ? value : getValue(values, SubOptionType.dateTo).value
    }].filter(v => !!v.value) || []);
  };

  private onChangeDateFrom = (value: Date) => this.onChangeDate(value, SubOptionType.dateFrom);
  private onChangeDateTo = (value: Date) => this.onChangeDate(value, SubOptionType.dateTo);

  private renderSpecifiedPeriod = () => {
    const { id, values, translation, locale } = this.props;

    const selected = !values || (values && values.some(v => v.optionType === OptionType.specified));

    const dateFrom = getValue(values, SubOptionType.dateFrom);
    const dateTo = getValue(values, SubOptionType.dateTo);

    return <div className="form-check">
      <input
        type="radio"
        id={`${id}_specified-date-range`}
        name={`${id}_date-range-option-type`}
        className="form-check-input visuallyhidden"
        value={OptionType.specified}
        checked={!!selected}
        onChange={this.onChange} />
      <label
        htmlFor={`${id}_specified-date-range`}
        className="form-check-label">
        <RadioSymbol />
        <b>{translation.filters_date_range_date_interval}</b>
      </label>

      {selected && <div className={styles.dateGroup}>
        <div>
          <label>{translation.filters_date_range_from}</label>
          <DateTime
            useTime={false}
            value={dateFrom.value}
            componentId={`${id}_disabled_date_from_picker`}
            className="dateTime"
            parseDate={parseAsDateUTC}
            createDate={createUTCDate}
            cloneDate={dateToUTC}
            locale={locale}
            onChange={this.onChangeDateFrom}
            captionWrapper={'form'}
            {...createFormatters(locale)}
          />
        </div>
        <div>
          <label>{translation.filters_date_range_to}</label>
          <DateTime
            useTime={false}
            value={dateTo.value}
            componentId={`${id}_disabled_date_to_picker`}
            className="dateTime"
            parseDate={parseAsDateUTC}
            createDate={createUTCDate}
            cloneDate={dateToUTC}
            locale={locale}
            onChange={this.onChangeDateTo}
            captionWrapper={'form'}
            {...createFormatters(locale)}
          />
        </div>
      </div>}
    </div>;
  };

  private renderNotSpecified = () => {
    const { id, values, translation } = this.props;

    const selected = values && values.some(v => v.optionType === OptionType.notSpecified);

    return <div className="form-check">
      <input
        type="radio"
        id={`${id}_not-specified-date-range`}
        name={`${id}_date-range-option-type`}
        className="form-check-input visuallyhidden"
        value={OptionType.notSpecified}
        checked={!!selected}
        onChange={this.onChange} />
      <label
        htmlFor={`${id}_not-specified-date-range`}
        className="form-check-label">
        <RadioSymbol />
        <div>
          <b>{translation.filters_not_specified_title}</b>
          <p className={styles.notSpecifiedSubtitle}>{translation.filters_not_specified_subtitle}</p>
        </div>
      </label>
    </div>;
  };

  public render() {
    return <>
      <MeatballPanel configuration={this.props.meatballPanelConfiguration} />
      {this.renderSpecifiedPeriod()}
      {this.renderNotSpecified()}
    </>;
  }
}
